import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

const AppView = r => require.ensure([], () => r(require('@/views/components/app-view')), 'AppView');
// 首页
const index = r => require.ensure([], () => r(require('@/views/example/index')), 'index');
// 同步参数设置
// const syncParaSetting = r => require.ensure([], () => r(require('@/views/example/syncParaSetting')), 'syncParaSetting');
const syncParaSetting = r => require.ensure([], () => r(require('@/views/example/companyList')), 'companyList');
const updateSetting = r => require.ensure([], () => r(require('@/views/example/syncParaSetting')), 'syncParaSetting');
// 基础数据匹配
const baseDataMatch = r => require.ensure([], () => r(require('@/views/example/baseDataMatch')), 'baseDataMatch');
// 业务接口管理
const busiInterManager = r => require.ensure([], () => r(require('@/views/example/busiInterManager')), 'busiInterManager');
// 定时任务管理
const syncSceneManager = r => require.ensure([], () => r(require('@/views/example/syncSceneManager')), 'syncSceneManager');
// 手动同步管理
const manualSyncSceneManager = r => require.ensure([], () => r(require('@/views/example/manualSyncSceneManager')), 'manualSyncSceneManager');
// 回传同步管理
const callBackSyncSceneManager = r => require.ensure([], () => r(require('@/views/example/callBackSyncSceneManager')), 'callBackSyncSceneManager');
// 同步场景日志
const syncSceneLogs = r => require.ensure([], () => r(require('@/views/example/syncSceneLogs')), 'syncSceneLogs');
// 业务场景明细 syncSceneDetail
const syncSceneDetail = r => require.ensure([], () => r(require('@/views/example/syncSceneDetail')), 'syncSceneDetail');
// 数据同步明细
const dataSyncRecord = r => require.ensure([], () => r(require('@/views/example/dataSyncRecord')), 'dataSyncRecord');
// 账号与权限
const accountAuthority = r => require.ensure([], () => r(require('@/views/example/accountAuthority')), 'accountAuthority');
// 数据拆分同步
const dataSplitSync = r => require.ensure([], () => r(require('@/views/example/dataSplitSync')), 'dataSplitSync');
const login = r => require.ensure([], () => r(require('@/views/common/login')), 'login');
const Error = r => require.ensure([], () => r(require('@/views/common/notfound')), 'error');
//电商仓枚举

const warehouseEnum = r => require.ensure([], () => r(require('@/views/example/warehouseEnum')), 'warehouseEnum');

//数据同步概览

const dataSyncList = r => require.ensure([], () => r(require('@/views/example/dataSyncList')), 'dataSyncList');
//SAP导出
const sapExport = r => require.ensure([], () => r(require('@/views/example/sapExport')), 'sapExport');

Vue.use(Router);
const routers = [
  {
    path: '/',
    component: AppView,
    redirect: to => {
      if (sessionStorage.getItem("redirectUrl")) {
        return sessionStorage.getItem("redirectUrl")
      } else {
        return '/index'
      }
    },
    meta: { title: '首页', requireLogin: true },
    children: [
      { path: '/index', name: 'index', component: index, meta: { title: '首页', requireLogin: true } },
      {
        path: '/syncParaSetting',
        name: 'syncParaSetting',
        component: syncParaSetting,
        meta: { title: '公司信息', requireLogin: true }
      },
      {
        path: '/updateSetting',
        name: 'updateSetting',
        component: updateSetting,
        meta: { title: '同步参数设置', requireLogin: true }
      },
      {
        path: '/baseDataMatch',
        name: 'baseDataMatch',
        component: baseDataMatch,
        meta: { title: '基础数据匹配', requireLogin: true }
      },
      {
        path: '/busiInterManager',
        name: 'busiInterManager',
        component: busiInterManager,
        meta: { title: '业务接口管理', requireLogin: true }
      },
      {
        path: '/syncSceneManager',
        name: 'syncSceneManager',
        component: syncSceneManager,
        meta: { title: '定时任务管理', requireLogin: true }
      },
      {
        path: '/manualSyncSceneManager',
        name: 'manualSyncSceneManager',
        component: manualSyncSceneManager,
        meta: { title: '手动同步管理', requireLogin: true }
      },
      {
        path: '/callBackSyncSceneManager',
        name: 'callBackSyncSceneManager',
        component: callBackSyncSceneManager,
        meta: { title: '回传同步管理', requireLogin: true }
      },
      {
        path: '/syncSceneLogs',
        name: 'syncSceneLogs',
        component: syncSceneLogs,
        meta: { title: '同步场景日志', requireLogin: true }
      },
      {
        path: '/syncSceneDetail',
        name: 'syncSceneDetail',
        component: syncSceneDetail,
        meta: { title: '业务场景明细', requireLogin: true }
      },
      {
        path: '/dataSyncRecord',
        name: 'dataSyncRecord',
        component: dataSyncRecord,
        meta: { title: '数据同步明细', requireLogin: true }
      },
      {
        path: '/accountAuthority',
        name: 'accountAuthority',
        component: accountAuthority,
        meta: { title: '账号与权限', requireLogin: true }
      },
      {
        path: '/dataSplitSync',
        name: 'dataSplitSync',
        component: dataSplitSync,
        meta: { title: '数据拆分同步', requireLogin: true }
      },
      {
        path: '/shedewarehouseenum',
        name: 'shedewarehouseenum',
        component: warehouseEnum,
        meta: { title: '电商仓枚举', requireLogin: true }
      },
      {
        path: '/dataSyncList',
        name: 'dataSyncList',
        component: dataSyncList,
        meta: { title: '数据同步概览', requireLogin: true }
      },
      {
        path: '/sapExport',
        name: 'sapExport',
        component: sapExport,
        meta: { title: 'SAP', requireLogin: true }
      }
    ]
  },
  { path: '/login', name: 'login', component: login, meta: { title: '登录', requireLogin: false } }, //登录
  { path: '*', name: '404', component: Error, meta: { title: '404', requireLogin: false } } // 404
];

const router = new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: routers
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 路由跳转之前
router.beforeEach((to, from, next) => {
  // 显示loading过渡效果
  store.dispatch("ChangeLoading", true);
  if (to.meta.requireLogin) {   // 判断该路由是否需要登录权限
    if (!window.sessionStorage) {
      Message({
        showClose: true,
        message: "浏览器不支持本地存储功能，建议您使用chrome浏览器效果更佳！",
        type: "error"
      });
      return false;
    }
    if (window.sessionStorage.getItem("loginUserBaseInfo")) {  // 判断本地存储是否存在用户信息
      next();
    } else {  // 没有用户信息则跳转到登录界面
      store.dispatch("ChangeLoading", false);
      next({
        path: "/login"
      });
    }
  } else { // 路由不需要登录 直接跳转
    next();
  }
  next();
  // 更新页面title
  window.document.title = to.meta.title
});


// 路由跳转之后
router.afterEach(function (to) {
  // 关闭loading过渡效果
  store.dispatch("ChangeLoading", false);
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js